module.exports = __webpack_public_path__ + "assets/livanto.52c80aa5.svg";